import { api } from "@/configs/axiosInstance";
import {
  CreateGraduateGuestDto,
  EventIndexPaginatedDto,
  EventIndexQueryDto,
  GraduateDetailsDto,
  TransferGraduateEntranceDto,
  UpdateGraduateGuestDto,
} from "@/pages/myEvents/types";

export const useEvent = () => {
  const getEvents = ({
    name,
    typeName,
    date,
    local,
    page,
  }: EventIndexQueryDto) => {
    let params = `page=${page}&perPage=${9999}`;

    if (name) {
      params = `${params}&name=${name}`;
    }

    if (typeName) {
      params = `${params}&typeName=${typeName}`;
    }

    if (date) {
      params = `${params}&date=${date}`;
    }

    if (local) {
      params = `${params}&local=${local}`;
    }

    return api.get<EventIndexPaginatedDto>(`/event-graduate/me?${params}`);
  };

  const getGraduateDetails = (id: number) => {
    return api.get<GraduateDetailsDto>(
      `/event-graduate/${id}/graduate-details`
    );
  };

  const getGraduateByEvent = (id: number) => {
    return api.get(`/event-graduate/by-event/${id}`);
  };

  const createGraduateGuest = (body: CreateGraduateGuestDto) => {
    return api.post(`/event-graduate/create-graduate-guest`, body);
  };

  const updateGraduateGuest = (id: number, body: UpdateGraduateGuestDto) => {
    return api.put(`/event-graduate/graduateGuest/${id}`, body);
  };

  const transferGraduateEntrance = (body: TransferGraduateEntranceDto) => {
    return api.patch(`/event-graduate/entrance-transfer`, body);
  };

  const sendInviteMail = (guestId: number) => {
    return api.post(`/event-graduate/send-mail/${guestId}`);
  };

  const donwloadInvite = (id: number) => {
    return api.get(`/event-graduate/download-invite/${id}`, {
      responseType: "blob",
    });
  };

  const deleteGuest = (id: number) => {
    return api.delete(`/event-graduate/graduate-guest/${id}`);
  };

  return {
    getEvents,
    getGraduateDetails,
    getGraduateByEvent,
    createGraduateGuest,
    updateGraduateGuest,
    transferGraduateEntrance,
    sendInviteMail,
    donwloadInvite,
    deleteGuest,
  };
};
